import { gql } from '@apollo/client'

export const remarksActivityFragment = ` _id
    activity
    isDeleted
    updatedAt
    createdAt
    by {
      _id
      profile {
        _id
        name
      }
    }`

export const mutationCreateRemarksActivityMention = (entityName: string) => {
  const mutation = `
    mutation create${entityName}_remarksActivityMention($input: CreateRemarksActivityMentionArgs!) {
      create${entityName}_remarksActivityMention(input: $input) {
        _id
        remarksActivity {
          ${remarksActivityFragment}
        }
      }
    }
  `

  return gql(mutation)
}

export const mutationUpdateRemarksActivityMention = (entityName: string) => {
  const mutation = `
    mutation update${entityName}_remarksActivityMention($input: UpdateRemarksActivityMentionArgs!) {
      update${entityName}_remarksActivityMention(input: $input) {
        _id
        remarksActivity {
          ${remarksActivityFragment}
        }
      }
    }
  `
  return gql(mutation)
}

export const mutationCreateRemarksActivity = (entityName: string) => {
  const mutation = `
    mutation create${entityName}_remarksActivity($input: JSON!, $filter: JSON!) {
      create${entityName}_remarksActivity(input: $input, filter: $filter) {
        _id
        remarksActivity {
          ${remarksActivityFragment}
        }
      }
    }
  `

  return gql(mutation)
}

export const mutationUpdateRemarksActivity = (entityName: string) => {
  const mutation = `
    mutation update${entityName}_remarksActivity($input: JSON!, $filter: JSON!) {
      update${entityName}_remarksActivity(input: $input, filter: $filter) {
        _id
        remarksActivity {
          ${remarksActivityFragment}
        }
      }
    }
  `
  return gql(mutation)
}
